import React, { useEffect } from "react";
import Breadcrumbs from "../../../customComponent/BreadCrumbs";
import {
  FORM_STATUS_STYLES,
  ImageBaseUrl,
  breadcrumbNameMap,
} from "../../../utils/helperData";
import { FaArrowLeft } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router";
import { VIEW_MANAGE_PROJECT_DETAILS } from "../../../utils/RouteConstant";
import FormSection from "../../../customComponent/FormSection/FormSection";
import FormField from "../../../customComponent/FormField/FormField";
import { useDispatch, useSelector } from "react-redux";
import { GetIsometricMaterialDetails } from "../../../../redux/action/InspectionDetails/InspectionDetailsAction";
import { AiOutlineDownload } from "react-icons/ai";
import frame_Icon from "../../../../asesst/file_image.png";

const ViewDetailsNewInspection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { inspectionDetaildata, isLoading, error } = useSelector(
    (state) => state.inspectionDetails,
  );
  const projectDetails = useSelector((state) => state.project.projectDetails);
  console.log("prohect ", projectDetails?.name);
  useEffect(() => {
    if (location.state?.data?._id) {
      dispatch(GetIsometricMaterialDetails(location.state.data._id));
    }
  }, [dispatch, location.state?.data?._id]);

  const handleGoBack = () => {
    navigate(
      `${VIEW_MANAGE_PROJECT_DETAILS}/${inspectionDetaildata?.project_id}`,
      {
        state: {
          selectedTab: "Inspection Details",
          selectedInspectionIndex: 0,
        },
      },
    );
  };
  if (isLoading) {
    return (
      <>
        <span className="animate-spin">⌛</span>
        Loading...
      </>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const baseUrl = ImageBaseUrl;
  const handleDownload = (e, fileUrl, fileName) => {
    e.preventDefault();
    console.log("fileurl", fileUrl);
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        console.log("file url", blob);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((e) => alert("An error occurred while downloading the file.", e));
  };
  const truncateString = (str) => {
    if (str?.length > 15) {
      return str.slice(0, 15) + "...";
    }
    return str;
  };

  const renderDocumentSection = () => {
    const { document } = inspectionDetaildata || {};

    if (!document || document.length === 0) return null;

    const renderDocumentItem = (doc, index) => (
      <div
        key={index}
        className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
      >
        <div className="flex items-center space-x-3">
          <img
            src={frame_Icon}
            alt="Inspector Document"
            className="w-12 h-12 rounded-lg"
          />
          <div>
            <p className="font-semibold">
              {truncateString(doc.name || "Document")}
            </p>
          </div>
        </div>
        <button
          className="text-[#1C3664]"
          onClick={(e) => handleDownload(e, `${baseUrl}${doc}`, doc)}
        >
          <AiOutlineDownload size={24} />
        </button>
      </div>
    );

    return <FormSection>{document.map(renderDocumentItem)}</FormSection>;
  };

  const renderMultipleFields = (label, data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return null;
    }
    return (
      <>
        {data.map((item, index) => (
          <FormField key={index} label={label} value={item.name} />
        ))}
      </>
    );
  };
  return (
    <div>
      <div className=" mb-6">
        <h2 className="text-3xl font-bold mb-6">Material Inspection</h2>
        <div className="flex justify-between items-center">
          <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
          <div className="flex gap-2 items-center">
            {projectDetails?.document && (
              <img
                src={`${ImageBaseUrl}${projectDetails.document}`}
                alt="not"
                className="preview-image w-[3.5rem] h-12 bg-cover bg-center rounded-3xl mr-2.5"
              />
            )}
            <span className="text-xl font-semibold">
              Project Name:-
              <span className="text-blue-500">
                {" "}
                {projectDetails?.name || location?.state?.data?.project_name}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div className="flex items-center text-2xl font-base font-poppins mb-8 text-[#202224]">
          <FaArrowLeft className="cursor-pointer" onClick={handleGoBack} />
          <h3
            className="text-lg p-2 font-semibold cursor-pointer"
            onClick={handleGoBack}
          >
            Go Back
          </h3>
        </div>
        <FormSection title="Inspection Data">
          <FormField
            label="Inspection Location"
            value={inspectionDetaildata?.locName?.name}
          />
          <FormField
            label="Inspection Date"
            value={
              inspectionDetaildata?.ins_date
                ? new Date(inspectionDetaildata?.ins_date).toLocaleDateString(
                    "en-US",
                    {
                      month: "2-digit",
                      day: "2-digit",
                      year: "numeric",
                    },
                  )
                : "-"
            }
          />
          <FormField
            label="Acceptance Criteria"
            value={inspectionDetaildata?.ins_criteria}
          />
          <FormField
            label="Inspection Procedure"
            value={inspectionDetaildata?.ins_procedures}
          />
          {/* <FormField
            label="Reference Number"
            value={inspectionDetaildata?.ref_no}
          /> */}
        </FormSection>

        <FormSection title="Material Receipt">
          <FormField
            label="Receiving #"
            value={inspectionDetaildata?.receiving}
          />
          <FormField label="Line #" value={inspectionDetaildata?.line} />
          <FormField
            label="Purchase Order"
            value={inspectionDetaildata?.purchase_order}
          />
          <FormField
            label="Packing Slip"
            value={inspectionDetaildata?.packing_slip}
          />
          <FormField
            label="Material Type"
            value={inspectionDetaildata?.material_type}
          />
        </FormSection>

        <FormSection title="Valves/Components">
          <FormField
            label="Model Or Part Number"
            value={inspectionDetaildata?.model_no}
          />
          <FormField
            label="Serial Number"
            value={inspectionDetaildata?.serial_no}
          />
          <FormField label="Tag ID" value={inspectionDetaildata?.tag_id} />
        </FormSection>

        <FormSection title="Material ID">
          {/* {renderMultipleFields(
            "Manufacturer",
            inspectionDetaildata?.manufacturerName
          )} */}
          <FormField
            label="Manufacturer"
            value={inspectionDetaildata?.manufacturerName?.name}
          />
          <FormField
            label="Classification"
            value={inspectionDetaildata?.classification}
          />
          <FormField
            label="Description"
            value={inspectionDetaildata?.description_id}
          />
          <FormField label="Size" value={inspectionDetaildata?.size_id} />
          {/* {renderMultipleFields("Size", inspectionDetaildata?.sizeName)} */}
          <FormField label="Heat # (1)" value={inspectionDetaildata?.heat1} />
          <FormField label="Heat # (2)" value={inspectionDetaildata?.heat2} />
          <FormField label="Heat # (3)" value={inspectionDetaildata?.heat3} />
          <FormField label="Heat # (4)" value={inspectionDetaildata?.heat4} />
          <FormField label="Ends" value={inspectionDetaildata?.endName?.name} />
          <FormField
            label="Type/Grade"
            value={inspectionDetaildata?.typeName?.name}
          />
          {/* {renderMultipleFields("Ends", inspectionDetaildata?.endName)}
          {renderMultipleFields("Type/Grade", inspectionDetaildata?.typeName)} */}
          <FormField
            label="O2 Clean"
            // value={inspectionDetaildata?.o2_clean ? "True" : "False"}
            value={inspectionDetaildata?.o2_clean}
          />
          <FormField
            label="Surfac Finish"
            value={inspectionDetaildata?.surfaceName?.name}
          />
        </FormSection>

        <FormSection title="Inspection Data">
          <FormField
            label="Total Quantity Inspected"
            value={inspectionDetaildata?.total_ins_quantity}
          />
          <FormField
            label="Wall Thickness: Quantity (ACC, REJ)"
            value={inspectionDetaildata?.wall_thickness}
          />
          <FormField
            label="Visual Inspection"
            value={inspectionDetaildata?.visual_inspection}
          />
          <FormField
            label="Weld Seam Inspection: Quantity (ACC, REJ)"
            value={inspectionDetaildata?.weld_inspection}
          />
          <FormField
            label="Sample Markings"
            value={inspectionDetaildata?.sample_marking}
          />
          <FormField
            label="Ovality: Quantity (ACC,Rej)"
            value={inspectionDetaildata?.ovality}
          />
          <FormField
            label="Material Documentation"
            value={inspectionDetaildata?.material_doc}
          />
          <FormField
            label="Profilometer Test(S): Quantity (ACC,Rej)"
            value={inspectionDetaildata?.profilometer}
          />
          <FormField
            label="Material Specification"
            value={inspectionDetaildata?.mat_specification}
          />
          <FormField
            label="XRF Test(S): Quantity (ACC, REJ)"
            value={inspectionDetaildata?.xrf}
          />
        </FormSection>

        <FormSection title="Inspection Results">
          <FormField
            label="Total Quantity Accepted"
            value={inspectionDetaildata?.total_accepted_quantity || 0}
          />
          <FormField
            label="Total Quantity Rejected"
            value={inspectionDetaildata?.total_reject_quantity || 0}
          />
          <FormField
            label="NCR Generated"
            value={inspectionDetaildata?.ncr ? "True" : "False"}
          />
          <FormField
            label="Status"
            value={
              FORM_STATUS_STYLES[inspectionDetaildata?.form_status]?.label ||
              "-"
            }
          />
        </FormSection>
        {renderDocumentSection()}
      </div>
    </div>
  );
};

export default ViewDetailsNewInspection;
